import { payFrequency } from 'types';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { getGraceType } from 'types/graceType';
import { colors } from 'globalStyle';
import { useMediaQuery } from 'hooks';
import bankSafeBox from 'assets/icons/safeBoxPrimaryColor.svg';
import money from 'assets/icons/moneyUpwardPrimaryColor.svg';
import calendar from 'assets/icons/calendarColorPrimary.svg';
import returnMoney from 'assets/icons/returnMoneyPrimaryColor.svg';
import { calculateDifferenceBetweenDates } from 'util/calculateDifferenceBetweenDates';
import { calculatePercentage } from 'util/percent';

const handlePeriod = (period) => {
  if (!period) return 'Sin período de gracia';
  if (period > 1) {
    return `${period} meses`;
  }
  return `${period} mes`;
};

const handleGraceType = (graceType) => {
  if (!graceType) {
    return 0;
  }
  const findGraceType = getGraceType.find((type) => type.id === graceType);
  return findGraceType;
};

const borderColor = `1px solid ${colors.input.inactive}`;

const handleWarranty = (isWarranty, warrantyCompanyName, warranty) => {
  if (isWarranty) {
    return ` ${warrantyCompanyName} ${(warranty * 100).toFixed()}%`;
  }
  return 'Sin garantía';
};

export const investmentConditions = (project) => {
  const tipogracia = handleGraceType(project?.graceType);
  const isDesktop = useMediaQuery(1023);

  if (!isDesktop) {
    return [
      {
        image: returnMoney,
        name: 'Tasa:',
        value: `${calculatePercentage(project?.ieaTax)}% E.A.`,
      },
      {
        image: money,
        name: 'Tiempo de préstamo:',
        value: handlePeriod(project?.returnTime),
      },
      {
        image: bankSafeBox,
        name: 'Garantía:',
        value: handleWarranty(
          project?.isWarranty,
          project?.warrantyCompanyName,
          project?.warranty,
        ),
      },
      {
        image: calendar,
        name: 'Recolección de recursos:',
        value: (calculateDifferenceBetweenDates(project?.endDate)),
      },
    ];
  }

  return [
    {
      name: 'Tasa',
      value: `${calculatePercentage(project?.ieaTax)}% E.A.`,
    },
    {
      name: 'Pago intereses',
      value: capitalizeFirstLetterString(
        payFrequency[
          project?.frequencyInterest || payFrequency[project?.frequency]
        ],
      ),
      style: { borderLeft: borderColor, borderRight: borderColor },
    },
    {
      name: 'Pago capital',
      value:
        project?.simulatorType === 'BANK_VISION'
          ? capitalizeFirstLetterString(payFrequency[project?.frequency])
          : 'Último período',
    },
    {
      name: 'Plazo',
      value: handlePeriod(project?.returnTime),
      style: { borderTop: borderColor, borderBottom: borderColor },
    },
    {
      name: 'Período de gracia',
      value: handlePeriod(project?.gracePeriod),
      style: {
        border: borderColor,
      },
    },
    {
      name: 'Tipo período de gracia',
      value: tipogracia.name,
      style: {
        borderTop: borderColor,
        borderBottom: borderColor,
      },
    },
  ];
};
